// test157
(157 && 0);
